import type {DestinationConnection} from '@gl/types/destinations.js';
import {DestinationType} from '@gl/types/destinations.js';
import type {Nullable} from '@gl/lit/types/general.js';
import type {
  MappedMatchField,
  MatchField,
  SelectedFieldValue,
} from '@gl/types/journeys.js';
import {isUndefined} from '@gl/lit/utils/index.js';

export function getDestinationType(destination: DestinationConnection) {
  if (destination.platform_type === DestinationType.ZETA) {
    return DestinationType.ZETA;
  }

  if (destination.platform_type === DestinationType.CSV) {
    return DestinationType.CSV;
  }

  if (!isUndefined(destination.is_mlb)) return DestinationType.MLB;

  return DestinationType.NONMLB;
}

export function transformMappedFields(
  matchFields?: MappedMatchField[]
): Record<string, Nullable<SelectedFieldValue> | string[]> {
  if (!matchFields || !matchFields.length) return {};
  return matchFields.reduce((acc, matchField) => {
    return {...acc, ...matchField.mappedValue};
  }, {});
}

export function findMatchFieldLabel(
  matchFields: MappedMatchField[],
  matchField: MatchField
) {
  const existingMatchField = matchFields.find(
    mappedField => mappedField.label === matchField.label
  );
  return existingMatchField?.label ?? '';
}
